module.exports = __webpack_public_path__ + "img/wsPublic.338c55d3.png";